import { Regret } from "src/screens/Public/regret";
import { MenuItem } from "../../../../commons/ui/menu";

export const routes: MenuItem[] = [
  {
    key: "publicRegretMain",
    basePath: "/",
    target: {
      component: Regret,
      path: "/",
    },
    enabled: true,
    icon: "List",
    text: "Cancelar Compra",
    children: [],
    default: true,
  },
];
